import { extendTheme } from '@mui/joy/styles';

export const customTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          '50': '#ecfdf5',
          '100': '#d1fae5',
          '200': '#a7f3d0',
          '300': '#6ee7b7',
          '400': '#34d399',
          '500': '#10b981',
          '600': '#059669',
          '700': '#047857',
          '800': '#065f46',
          '900': '#064e3b',
          // Botões sólidos - verde esmeralda elegante
          solidBg: '#059669',
          solidActiveBg: '#047857',
          solidHoverBg: '#047857',
          solidDisabledBg: '#e8f5e8',        // Verde muito claro para desativado
          solidDisabledColor: '#6b8e6b',     // Verde suave para texto desativado
          // Botões soft
          softBg: '#ecfdf5',
          softHoverBg: '#d1fae5',
          softActiveBg: '#a7f3d0',
          softDisabledBg: '#f8f8f8',         // Fundo claro para desativado
          softColor: '#047857',
          softDisabledColor: '#b0b0b0',      // Texto cinza claro para desativado
          // Botões plain
          plainColor: '#059669',
          plainHoverBg: '#ecfdf5',
          plainActiveBg: '#d1fae5',
          plainDisabledColor: '#c0c0c0',     // Cinza claro para desativado
          // Botões outlined
          outlinedBorder: '#10b981',
          outlinedColor: '#059669',
          outlinedHoverBg: '#ecfdf5',
          outlinedActiveBg: '#d1fae5',
          outlinedDisabledBorder: '#e0e0e0',
          outlinedDisabledColor: '#c0c0c0',  // Cinza claro para desativado
        },
        warning: {
          '50': '#fefaf2',
          '100': '#fef2d6',
          '200': '#fde4ad',
          '300': '#fcd274',
          '400': '#f9bf47',
          '500': '#d4a73b',        // Cor base sugerida pelo usuário
          '600': '#b8922f',
          '700': '#9c7b26',
          '800': '#7d6220',
          '900': '#5f4a19',
          // Botões sólidos - dourado bronze elegante mais escuro
          solidBg: '#b8922f',
          solidActiveBg: '#9c7b26',
          solidHoverBg: '#9c7b26',
          solidDisabledBg: '#f5f0e8',
          solidDisabledColor: '#8b7355',
          // Botões soft
          softBg: '#fefaf2',
          softHoverBg: '#fef2d6',
          softActiveBg: '#fde4ad',
          softDisabledBg: '#f8f8f8',
          softColor: '#9c7b26',
          softDisabledColor: '#b0b0b0',
          // Botões plain
          plainColor: '#d4a73b',
          plainHoverBg: '#fefaf2',
          plainActiveBg: '#fef2d6',
          plainDisabledColor: '#c0c0c0',
          // Botões outlined
          outlinedBorder: '#d4a73b',
          outlinedColor: '#d4a73b',
          outlinedHoverBg: '#fefaf2',
          outlinedActiveBg: '#fef2d6',
          outlinedDisabledBorder: '#e0e0e0',
          outlinedDisabledColor: '#c0c0c0',
        }
      }
    },
    dark: {
      palette: {
        primary: {
          '50': '#0a2818',               // Verde escuro mais forte
          '100': '#0f3d20',              // Verde escuro forte
          '200': '#1f7a1f',              // Verde médio mais vibrante (sugestão do usuário)
          '300': '#2d8f47',              // Verde médio-claro
          '400': '#3ba55d',              // Verde equilibrado (substitui o #16a085)
          '500': '#48cc6c',              // Verde claro vibrante
          '600': '#5dd68a',              // Verde brilhante
          '700': '#6ee7b7',              // Verde bem claro
          '800': '#a7f3d0',              // Verde claro suave
          '900': '#d1fae5',              // Verde quase branco
          // Botões sólidos - verde mais forte e contrastante no dark
          solidBg: '#1f7a1f',            // Verde forte sugerido pelo usuário
          solidActiveBg: '#2d8f47',      // Verde médio-claro (remove #16a085)
          solidHoverBg: '#3ba55d',       // Verde equilibrado
          solidDisabledBg: '#2a3f2a',    // Verde escuro para desativado
          solidDisabledColor: '#7a9a7a', // Verde suave para texto desativado
          // Botões soft
          softBg: '#0a2818',             // Verde escuro forte
          softHoverBg: '#0f3d20',
          softActiveBg: '#1f7a1f',
          softDisabledBg: '#1a1a1a',     // Fundo escuro para desativado
          softColor: '#48cc6c',          // Texto verde brilhante
          softDisabledColor: '#555555',  // Texto cinza para desativado
          // Botões plain
          plainColor: '#48cc6c',         // Verde brilhante e contrastante
          plainHoverBg: '#0a2818',
          plainActiveBg: '#0f3d20',
          plainDisabledColor: '#555555', // Cinza para desativado
          // Botões outlined
          outlinedBorder: '#1f7a1f',     // Verde forte
          outlinedColor: '#48cc6c',      // Verde brilhante
          outlinedHoverBg: '#0a2818',
          outlinedActiveBg: '#0f3d20',
          outlinedDisabledBorder: '#333333',
          outlinedDisabledColor: '#555555', // Cinza para desativado
        },
        warning: {
          '50': '#2a1f0f',               // Bronze escuro
          '100': '#3a2915',              // Bronze escuro médio
          '200': '#5f4a19',              // Bronze médio escuro
          '300': '#7d6220',              // Bronze médio
          '400': '#9c7b26',              // Bronze vibrante
          '500': '#d4a73b',              // Bronze dourado brilhante (cor base)
          '600': '#e6bb52',              // Bronze claro
          '700': '#f2ce6a',              // Bronze bem claro
          '800': '#f7db87',              // Bronze suave
          '900': '#fbe8a6',              // Bronze quase branco
          // Botões sólidos - bronze dourado que funciona bem no dark
          solidBg: '#d4a73b',            // Bronze dourado vibrante
          solidActiveBg: '#b8922f',      // Mais escuro
          solidHoverBg: '#9c7b26',       // Ainda mais escuro
          solidDisabledBg: '#3d3227',
          solidDisabledColor: '#a68b68',
          // Botões soft
          softBg: '#2a1f0f',             // Bronze escuro
          softHoverBg: '#3a2915',
          softActiveBg: '#5f4a19',
          softDisabledBg: '#1a1a1a',
          softColor: '#e6bb52',          // Texto bronze claro
          softDisabledColor: '#555555',
          // Botões plain
          plainColor: '#e6bb52',         // Bronze claro contrastante
          plainHoverBg: '#2a1f0f',
          plainActiveBg: '#3a2915',
          plainDisabledColor: '#555555',
          // Botões outlined
          outlinedBorder: '#d4a73b',     // Bronze dourado
          outlinedColor: '#e6bb52',      // Bronze claro
          outlinedHoverBg: '#2a1f0f',
          outlinedActiveBg: '#3a2915',
          outlinedDisabledBorder: '#333333',
          outlinedDisabledColor: '#555555',
        }
      }
    }
  },
  // Mantenha outras configurações como fontFamily, spacing, etc.
  fontFamily: {
    body: 'Inter, "Helvetica Neue", Arial, sans-serif',
    display: 'Inter, "Helvetica Neue", Arial, sans-serif',
    code: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  }
});

export default customTheme; 